import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

export default function PaymentMethodFailurePage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const timer = setTimeout(() => {
            // Check for redirect param or stored URL
            const redirectParam = searchParams.get("redirect");
            const storedUrl = sessionStorage.getItem("pendingPodcastUrl");
            
            if (redirectParam) {
                navigate(redirectParam, { replace: true });
            } else if (storedUrl) {
                const encodedUrl = encodeURIComponent(storedUrl);
                navigate(`/podcasts/add?url=${encodedUrl}`, { replace: true });
            } else {
                navigate("/episodes", { replace: true });
            }
        }, 2000);

        return () => clearTimeout(timer);
    }, [navigate, searchParams]);

    return (
        <div className={cn("min-h-screen flex items-center justify-center", theme.colors.backgroundCream)}>
            <div
                className={cn(
                    "max-w-md w-full mx-4 p-8 rounded-2xl text-center",
                    "bg-white dark:bg-gray-800",
                    theme.borders.neubrutalism,
                    theme.shadows.neubrutalism,
                )}
            >
                <div className="w-16 h-16 mx-auto mb-6 text-red-500">
                    <XCircle className="w-full h-full" />
                </div>
                <h2 className="text-2xl font-black mb-4 text-gray-900 dark:text-white">Update Failed</h2>
                <p className="text-gray-600 dark:text-gray-300 mb-8">
                    We couldn't update your payment method. Redirecting you back...
                </p>
            </div>
        </div>
    );
}
